/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
import {
  ButtonEmpty,
  ContextMenu,
  htmlIdGenerator,
  Icon,
  notification,
  Outline,
  Popover,
} from '@antoree/ant-ui';
import {
  ABSENT_BY_STUDENT,
  ABSENT_BY_TEACHER,
  HAPPENED,
  HAPPENING,
  UNHAPPENED,
  UPCOMING,
} from 'constants/session';
import { useEffect, useState, memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { SessionAbsent } from 'services/session';
import { useToggle } from 'hooks';
import {
  CANNOT_JOIN,
  CAN_JOIN,
  VIDEO_RECORD,
  EDIT_UNIT,
  SEND_CONFIRM,
} from '../constants';

export type SessionActionsProps = {
  openAbsenceReason: () => void;
  openEditSessionModal: () => void;
  handleStudentNotJoinSession: () => void;
  onUndoAbsentSession: (issueId: number) => void;
  isMainCourse: boolean;
  isVisiableAbsenceReason?: boolean;
  courseId: number;
  sessionId: number;
  issues: {
    sessionAbsent: SessionAbsent;
  };
  isLoading: boolean;
  happenedStatus: number;
  openReceive50Modal: () => void;
  isPenalty: boolean;
  isLoadingConfirmNo: boolean;

  isLoadingSendConfirmationRequest: boolean;
  handleSendConfirmationRequest: () => void;
  onViewRecordings?: () => void;
};

const SessionActions: React.FC<SessionActionsProps> = props => {
  const {
    sessionId,
    openEditSessionModal,
    openAbsenceReason,
    onUndoAbsentSession,
    handleStudentNotJoinSession,
    onViewRecordings,
    isMainCourse,
    issues,
    isVisiableAbsenceReason,
    isLoading,
    happenedStatus,
    openReceive50Modal,
    isLoadingConfirmNo,
    isLoadingSendConfirmationRequest,
    handleSendConfirmationRequest,
  } = props;
  const [isPopoverOpen, setPopover] = useState(false);
  const { DotsVerticalIcon } = Outline;
  const CANCEL_SESSION = 0;
  const PANEL = {
    id: CANCEL_SESSION,
    title: (
      <FormattedMessage
        id="session_actions.session_id"
        defaultMessage="Session ID {sessionId}"
        values={{ sessionId }}
      />
    ),
    items: [
      {
        id: VIDEO_RECORD,
        name: (
          <FormattedMessage
            id="session_actions.view_recordings"
            defaultMessage="View recordings"
          />
        ),
        icon: 'videoPlayer',
        // panel: 1,
        onClick: () => {
          if (onViewRecordings) {
            onViewRecordings();
          } else {
            notification.error({
              title: <FormattedMessage defaultMessage="Not Implemented" />,
            });
          }
        },
      },
      {
        id: CANNOT_JOIN,
        name: (
          <span style={{ color: '#ED0000' }}>
            <FormattedMessage
              id="session_actions.cancel_session"
              defaultMessage="Cancel Session"
            />
          </span>
        ),

        icon: <Icon type="alert" color="#ED0000" />,
        onClick: () => {
          // if (isPenalty) {
          //   openAlertAbsence();
          //   return;
          // }
          openAbsenceReason();
        },
      },
      // {
      //   id: CANNOT_JOIN,
      //   name: (
      //     <span style={{ color: '#ED0000' }}>
      //       Student can’t join this session
      //     </span>
      //   ),
      //   disabled: isLoadingConfirmNo,
      //   icon: <Icon type="alert" color="#ED0000" />,
      //   onClick: () => {
      //     handleStudentNotJoinSession();
      //   },
      // },
      {
        id: CAN_JOIN,
        name: (
          <span style={{ color: '#0AA263' }}>
            <FormattedMessage
              id="session_actions.i_can_join"
              defaultMessage="I can join this session"
            />
          </span>
        ),
        icon: !isLoading && <Icon type="check" color="#0AA263" />,
        onClick: () => {
          onUndoAbsentSession(issues?.sessionAbsent?.id);
        },
      },
      {
        id: EDIT_UNIT,
        name: (
          <span>
            {happenedStatus === UNHAPPENED && (
              <FormattedMessage defaultMessage="Create make-up class" />
            )}
          </span>
        ),
        icon: 'documentEdit',
        onClick: () => {
          openEditSessionModal();
        },
      },
      {
        id: SEND_CONFIRM,
        name: (
          <span>
            <FormattedMessage
              id="session_actions.forgot_show_up"
              defaultMessage="I forgot to press 'Show up' this session"
            />
          </span>
        ),
        icon: 'training',
        onClick: () => {
          handleSendConfirmationRequest();
        },
        isLoading: isLoadingSendConfirmationRequest,
      },
    ],
  };

  const [panels, setPanels] = useState<any>([PANEL]);
  const addVideoRecordToPanelList = () => {
    const localPanels = [...panels];
    const index = localPanels.findIndex(item => item.id === CANCEL_SESSION);
    localPanels[index].items = [];
    localPanels[index].items.push({
      id: VIDEO_RECORD,
      name: (
        <FormattedMessage
          id="session_actions.view_recordings"
          defaultMessage="View recordings"
        />
      ),
      icon: 'videoPlayer',
      panel: 1,
    });

    setPanels(localPanels);
  };

  const removeEditSession = () => {
    const localPanels = [...panels];
    const index = localPanels.findIndex(item => item.id === CANCEL_SESSION);

    localPanels[index].items.filter((item: any) => item.id !== EDIT_UNIT);

    (localPanels[index].items = localPanels[index]?.items?.filter(
      (item: any) => item.id !== EDIT_UNIT && item.id !== SEND_CONFIRM,
    )),
      setPanels(localPanels);
  };
  const findSubPanelList = () => {
    const localPanels = [...panels];
    const index = localPanels.findIndex(item => item.id === CANCEL_SESSION);
    return localPanels[index].items;
  };
  const addICanJoin = (subPanels: Array<any>) => {
    subPanels?.push({
      id: CAN_JOIN,
      name: (
        <span style={{ color: '#0AA263' }}>
          <FormattedMessage
            id="session_actions.i_can_join"
            defaultMessage="I can join this session"
          />
        </span>
      ),
      icon: <Icon type="check" color="#0AA263" />,
      onClick: (event: Event) => {
        onUndoAbsentSession(issues?.sessionAbsent?.id);
      },
    });
  };
  const renderActions = (status: number) => {
    const localPanels = [PANEL];

    const index = localPanels.findIndex(item => item.id === CANCEL_SESSION);

    switch (status) {
      case UPCOMING:
        (localPanels[index].items = localPanels[index]?.items?.filter(
          (item: any) => item.id !== SEND_CONFIRM && item.id !== EDIT_UNIT,
        )),
          setPanels(localPanels);
        break;
      case HAPPENING:
        (localPanels[index].items = localPanels[index]?.items?.filter(
          (item: any) => item.id !== SEND_CONFIRM && item.id !== EDIT_UNIT,
        )),
          setPanels(localPanels);
        break;
      case UNHAPPENED:
        (localPanels[index].items = localPanels[index]?.items?.filter(
          (item: any) => item.id !== CANNOT_JOIN && item.id !== CAN_JOIN,
        )),
          setPanels(localPanels);
        break;
      case HAPPENED:
        addVideoRecordToPanelList();
        break;
    }
  };
  useEffect(() => {
    if (isVisiableAbsenceReason) {
      setPopover(false);
    }
  }, [isVisiableAbsenceReason]);
  useEffect(() => {
    if (issues) {
      if (issues?.sessionAbsent) {
        if (issues?.sessionAbsent?.absentBy === ABSENT_BY_TEACHER) {
          const subPanels = findSubPanelList();
          const indexCannotJoin = subPanels?.findIndex(
            (el: any) => el.id === CANNOT_JOIN,
          );
          if (indexCannotJoin !== -1) {
            subPanels.splice(indexCannotJoin, 1);
            const indexCanJoin = subPanels?.findIndex(
              (el: any) => el.id === CAN_JOIN,
            );
            if (indexCanJoin === -1) {
              addICanJoin(subPanels);
            }
          }
        }
        if (issues?.sessionAbsent?.absentBy === ABSENT_BY_STUDENT) {
          addVideoRecordToPanelList();
        }
      }
    }
    if (happenedStatus === UPCOMING || happenedStatus === HAPPENING) {
      const subPanels = findSubPanelList();
      const indexCanJoin = subPanels.findIndex((el: any) => el.id === CAN_JOIN);
      if (indexCanJoin !== -1) {
        subPanels.splice(indexCanJoin, 1);
      }
      const indexCanNotJoin = subPanels.findIndex(
        (el: any) => el.id === CANNOT_JOIN,
      );

      if (indexCanNotJoin === -1) {
        subPanels.push(
          {
            id: CANNOT_JOIN,
            name: (
              <span style={{ color: '#ED0000' }}>
                <FormattedMessage
                  id="session_actions.cancel_session"
                  defaultMessage="Cancel Session"
                />
              </span>
            ),
            icon: <Icon type="alert" color="#ED0000" />,
            onClick: () => {
              // if (isPenalty) {
              //   openAlertAbsence();
              //   return;
              // }
              openAbsenceReason();
            },
          },
          // {
          //   id: CANNOT_JOIN,
          //   name: (
          //     <span style={{ color: '#ED0000' }}>
          //       Student can’t join this session
          //     </span>
          //   ),
          //   icon: <Icon type="alert" color="#ED0000" />,
          //   disabled: isLoadingConfirmNo,
          //   onClick: () => {
          //     handleStudentNotJoinSession();
          //   },
          // },
        );
      }
    }
    if (isMainCourse) {
      renderActions(happenedStatus);
    } else {
      addVideoRecordToPanelList();
    }
    // if (!isMainCourse || (happenedStatus !== UPCOMING && !issues)) {
    //   if (happenedStatus === HAPPENING) {
    //     removeEditSession();
    //     return;
    //   }
    //   if (happenedStatus === UNHAPPENED) {
    //     renderNotHappened();
    //     return;
    //   }
    //   addVideoRecordToPanelList();
    // }
    setPopover(false);
  }, [issues, isMainCourse, happenedStatus]);

  return (
    <Popover
      id={htmlIdGenerator()()}
      button={
        <ButtonEmpty onClick={() => setPopover(!isPopoverOpen)}>
          <DotsVerticalIcon style={{ color: '#69707D' }} className="h-5 w-5" />
        </ButtonEmpty>
      }
      isOpen={isPopoverOpen}
      closePopover={() => setPopover(false)}
      panelPaddingSize="none"
      anchorPosition="downLeft"
    >
      <ContextMenu initialPanelId={0} panels={panels || []} />
    </Popover>
  );
};

export default memo(SessionActions);
